import React from 'react';
import {
  Box, Button, TextField, Grid, Typography, Paper, Alert, Link
} from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';

const UrlInput = ({
  url,
  setUrl,
  loading,
  fetchSuccess,
  fetchError,
  uploading,
  uploadSuccess,
  uploadedUrl,
  recordError,
  onGetHtml,
  onRecord,
  recording,
  canStop
}) => {
  return (
    <Paper 
      elevation={0}
      sx={{ 
        mb: 2, 
        p: { xs: 2, md: 3 }, 
        borderRadius: 3,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04)'
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1, color: '#888' }}>Website URL</Typography>
      <TextField
        fullWidth
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        variant="outlined"
        size="small"
        sx={{ bgcolor: 'white', borderRadius: 2, mb: 2, input: { borderRadius: 2, fontSize: 16, py: 1 } }}
        InputProps={{ style: { height: 45, fontSize: 16 } }}
      />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="contained"
            size="small"
            sx={{
              height: '36px',
              borderRadius: 2,
              fontWeight: 600,
              fontSize: '0.875rem',
              bgcolor: '#1677ff',
              boxShadow: 'none',
              textTransform: 'none',
              '&:hover': { bgcolor: '#156de0' }
            }}
            onClick={onGetHtml}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Get HTML'}
          </Button>
        </Grid>
    
        <Grid item xs={4}>
          <Button
            fullWidth
            variant="outlined"
            size="small"
            sx={{
              height: '36px',
              minWidth: '48px',
              borderRadius: 2,
              fontWeight: 600,
              fontSize: '0.875rem',
              borderColor: '#d0d5dd',
              color: '#344054',
              bgcolor: 'white',
              boxShadow: 'none',
              textTransform: 'none',
              '&:hover': { borderColor: '#1677ff', color: '#1677ff', bgcolor: '#f5f7fa' }
            }}
            onClick={onRecord}
            disabled={recording && !canStop}
          >
            <VideocamIcon sx={{ mr: 1, fontSize: '1rem' }} />
            {recording ? 'Stop Recording' : 'Record'}
          </Button>
        </Grid>
      </Grid>
      {fetchSuccess && (
        <Alert severity="success" sx={{ mt: 2, borderRadius: 2, bgcolor: '#eafbe6', color: '#388e3c' }}>
          Successfully fetched: <Link href={url} target="_blank" rel="noopener" underline="hover">{url}</Link>
        </Alert>
      )}
      {fetchError && (
        <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>{fetchError}</Alert>
      )}
      {uploading && (
        <Typography variant="body2" sx={{ color: '#1976d2', mt: 1 }}>
          Uploading video...
        </Typography>
      )}
      {uploadSuccess && uploadedUrl && (
        <Typography variant="body2" sx={{ color: '#388e3c', mt: 1 }}>
          Video uploaded: <a href={uploadedUrl} target="_blank" rel="noopener noreferrer">View Video</a>
        </Typography>
      )}
      {recordError && (
        <Typography variant="body2" sx={{ color: '#d32f2f', mt: 1 }}>
          {recordError}
        </Typography>
      )}
    </Paper>
  );
};

export default UrlInput; 